import ItemList from '../Page/ItemList';

export default ItemList;
